'use strict';

/* globals Modernizr */

/** @InviteToSiteController */
const _ = require('lodash');

function InviteToSiteController (
    $scope, AnalyticsService, Flux, IdentityService, SettingsService,
    SettingsActions, InviteToSiteActions, PlanStore
) {

  const vm = this;
  const InviteToSiteStore = Flux.Store.get('InviteToSiteStore');
  const MapStore = Flux.Store.get('MapStore');

  vm.currentSite = { };
  vm.position = 'center';

  vm.visible = false;
  vm.showCancelDialog = false;
  vm.showConfirmation = false;

  vm.isTouch = typeof Modernizr !== 'undefined' && Modernizr.touch;

  vm.error = '';
  vm.text = 'Invalid fields';
  vm.inputs = ['fname', 'lname', 'email'];

  vm.data = {
    fname: '',
    lname: '',
    email: ''
  };

  vm.isOrganizationAdmin = IdentityService.isOrganizationAdmin();

  vm._handleStoreChange = () => {

    vm.visible = InviteToSiteStore.get('dialogVisibility');
    vm.data = { fname: '', lname: '', email: '' };
  };

  vm.cancelShare = () => {

    InviteToSiteActions.CancelInviteToSite.dispatch();
  };

  vm.determineInvitationMethod = () => {
    if (vm.isOrganizationAdmin) {
      vm.doInvite();
    }
    else {
      vm.sendInviteRequest();
    }
  };

  vm.doInvite = () => {

    const data = vm.data;
    const org = IdentityService.getCurrentOrganization();
    const plan = PlanStore.get('current');

    SettingsActions.AddMember.dispatch({
      name: [data.fname, data.lname].join(' '),
      email: data.email,
      organizationId: org.id,
      planId: plan.id,
      projectId: MapStore.get('site').projectId
    });
  };

  vm.sendInviteRequest = () => {

    const data = vm.data;
    const currentSite = MapStore.get('site');
    const inviter = IdentityService.getUser();
    const org = IdentityService.getCurrentOrganization();
    const plan = PlanStore.get('current');

    const invitation = {
      name: [data.fname, data.lname].join(' '),
      email: data.email,
      organizationId: org.id,
      orgName: org.name,
      projectId: currentSite.projectId,
      projectName: currentSite.project.name,
      planId: plan.id, // TODO: bring this in dynamically
      fromName: [inviter.firstName, inviter.lastName].join(' '),
      fromUserId: inviter.id
    };

    AnalyticsService.track('[CORE] Invitations', 'Invitation Created', {
      organization: invitation.orgName,
      projectName: invitation.projectName,
      invitedBy: invitation.fromName,
      invitee: invitation.name,
      organizationId: org.id,
      projectId: currentSite.projectId
    });

    SettingsActions.SendInvitation.dispatch(invitation);
  };

  InviteToSiteStore.on(InviteToSiteStore.Events.Changed, vm._handleStoreChange.bind(vm), $scope);
}

InviteToSiteController.$inject = [
  '$scope', 'AnalyticsService', 'sbFlux', 'IdentityService', 'SettingsService',
  'SettingsActions', 'InviteToSiteActions', 'PlanStore'
];

module.exports = InviteToSiteController;



// WEBPACK FOOTER //
// ./src/app/dash/invite/InviteToSiteController.js